const escape=(value) => value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
const bare=(value) => String(value || '').trim().replace(/^https?:\/\//i,'');
const pattern=(link) => {
  const value=bare(link);
  return value ? new RegExp(`(^|[^\\w/.:@-])(?:https?://)?${escape(value)}(?![\\w/?#=&%-])`,'g') : null;
};

export const smsLinkMatches=(text,link) => !!pattern(link)?.test(text || '');
export const smsTrackingMismatch=(data) => !!(data.rebrandlyId && data.shortUrl && !smsLinkMatches(data.messageText,data.shortUrl));

// Меняем только прежнюю выбранную ссылку, не угадываем назначение других URL.
export function replaceSmsLink(text,previous,next) {
  const expression=pattern(previous);
  if (!expression || !next) return text;
  const destination=/^https?:\/\//i.test(next) ? next : `https://${next}`;
  return String(text || '').replace(expression,(_match,prefix) => `${prefix}${destination}`);
}

export function updateSmsTracking(previous,changes) {
  const next={...previous,...changes};
  if (previous.channel==='email' || !Object.prototype.hasOwnProperty.call(changes,'shortUrl') || changes.shortUrl===previous.shortUrl) return next;
  next.previousTrackingUrl=changes.shortUrl ? null : previous.shortUrl || previous.previousTrackingUrl;
  if (changes.shortUrl && !Object.prototype.hasOwnProperty.call(changes,'messageText')) next.messageText=replaceSmsLink(previous.messageText,previous.shortUrl || previous.previousTrackingUrl,changes.shortUrl);
  return next;
}
